import { reactive, ref } from 'vue';
import "ant-design-vue/es/modal/style/css";
import _Modal from "ant-design-vue/es/modal";
import "ant-design-vue/es/message/style/css";
import _message from "ant-design-vue/es/message";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
import "core-js/modules/es.array.push.js";
import { Post } from '@/api/Api';
const __default__ = {
  name: 'List',
  components: {},
  data() {
    tableHeight: '';
  },
  setup(props, context) {
    const DMConfig = reactive({
      AppName: '',
      Width: 0,
      Height: 0,
      Columns: [{
        title: "单据编号",
        dataIndex: "fBillNo",
        width: 100
      }, {
        title: "日期",
        dataIndex: "fDate",
        width: 120,
        align: 'center',
        customRender: record => {
          return record.record.fDate.replace(' 00:00:00', '');
        }
      }, {
        title: "审核日期",
        dataIndex: "fCheckDate",
        width: 120,
        align: 'center',
        customRender: record => {
          return record.record.fCheckDate.replace(' 00:00:00', '');
        }
      }, {
        title: "客户代码",
        dataIndex: "fNumber"
      }, {
        title: "客户名称",
        dataIndex: "fName"
      }, {
        title: "RK号",
        dataIndex: "fExplanation"
      }, {
        title: "已发货天数",
        dataIndex: "fDay",
        width: 100
      }, {
        title: "金额",
        dataIndex: "fAmount",
        width: 160,
        align: 'center'
      }, {
        title: "状态",
        dataIndex: "isSend",
        width: 80,
        align: 'center',
        customRender: record => {
          return record.record.isSend == '已收款' ? _createVNode("span", {
            "style": "color:red"
          }, [_createTextVNode("\u5DF2\u6536\u6B3E")]) : '未收款';
        }
      }],
      AmountSum: 0,
      QueryParam: {
        Type: 0
      },
      DataSource: [],
      selectedRowKeys: [],
      selectedRows: [],
      loading: false,
      RowKey: 'fInterID',
      ForkHeight: 10,
      //表格离低高度
      IsSelect: true,
      //序时簿是否支持选择
      IsMultipleSelect: false,
      //序时簿是否多选
      QueryWhere: {
        total: 0,
        //current: 2,
        pageSize: 100,
        showQuickJumper: true,
        showTotal: total => {
          return `共${total}条`;
        }
      }
    });
    const OnTableChange = (pag, filters, sorter) => {
      console.log(pag);
      //DMConfig.QueryWhere.current=pag.current;
      DMConfig.QueryWhere.pageSize = pag.pageSize;
      DMConfig.QueryParam.PageNo = pag.current;
      LoadData(filters, sorter);
    };
    const onSelectChange = (selectedRowKeys, selectedRows) => {
      //console.log(selectedRowKeys)
      //console.log(selectedRows)
      DMConfig.selectedRowKeys = selectedRowKeys;
      DMConfig.selectedRows = selectedRows;
      DMConfig.AmountSum = 0;
      selectedRows.forEach(item => {
        //console.log(item.fAmount)
        DMConfig.AmountSum += item.fAmount;
      });
    };
    const Refresh = (bool = false) => {
      bool && (DMConfig.QueryWhere = Object.assign(DMConfig.QueryWhere, {
        current: 1
      }));
      LoadData();
    };
    const LoadData = (filters, sorter) => {
      var _this = this;
      DMConfig.loading = true;
      if (DMConfig.QueryParam.Date) {
        var d = DMConfig.QueryParam.Date[0];
        console.log(d.$d.getMonth());
        DMConfig.QueryParam.Start = d.$y + '-' + (d.$M + 1) + '-' + d.$D;
        d = DMConfig.QueryParam.Date[1];
        DMConfig.QueryParam.End = d.$y + '-' + (d.$M + 1) + '-' + d.$D;
      } else {
        DMConfig.QueryParam.Start = '';
        DMConfig.QueryParam.End = '';
      }

      //DMConfig.DataSource=[];
      //DMConfig.QueryParam.SearchValue = "";
      //DMConfig.QueryParam.PageNo = DMConfig.QueryWhere.current;
      DMConfig.QueryParam.PageSize = DMConfig.QueryWhere.pageSize;
      Post("dm/PIList", DMConfig.QueryParam).then(res => {
        let DataSource = res.data.rows;
        DMConfig.QueryWhere.total = res.data.totalRows;
        //DMConfig.QueryWhere.current=res.data.current;
        //DMConfig.QueryWhere.pageSize=res.data.pageSize;
        DMConfig.DataSource = DataSource;

        // _this.
        // if (_this.$refs.table) {
        //        _this.$refs.table.refresh(); // 刷新表格组件显示最新数据
        //    }

        DMConfig.loading = false;
      });
    };
    const GetTableYesNoCol = record => {
      if (record.value) return _createVNode(_resolveComponent("a-tag"), {
        "color": 'rgb(5, 160, 69)'
      }, {
        default: () => [_createTextVNode(" \u662F ")]
      });else return _createVNode(_resolveComponent("a-tag"), {
        "color": 'rgb(255, 0, 51)'
      }, {
        default: () => [_createTextVNode(" \u5426 ")]
      });
    };
    const OnQuery = () => {
      DMConfig.selectedRowKeys = [];
      DMConfig.selectedRows = [];
      Refresh(true);
    };
    const OnCreate = () => {
      DMPriceref.value.Open(0, 800, 0);
    };
    const OnSend = IsSend => {
      let _this = this;
      let Ids = [];
      DMConfig.selectedRows.forEach(m => {
        Ids.push(Number(m.fInterID));
      });
      Ids = Array.from(new Set(Ids));
      if (Ids.length == 0) {
        _message.error('请选择需要设置的行!');
      } else {
        _Modal.confirm({
          title: '提示',
          centered: true,
          content: '确认要设置选中的数据吗?',
          onOk: () => {
            DMConfig.loading = true;
            Post("DM/SetPI?IsSend=" + IsSend, Ids).then(res => {
              DMConfig.loading = false;
              if (res.succeeded) {
                _message.success('设置成功');
                OnQuery();
              } else {
                _message.error('设置失败：' + res.errors);
              }
            }).catch(err => {
              _message.error('设置错误：' + err.errors);
            });
          }
        });
      }
    };
    const DateFormat = text => {
      text = text.substring(0, 10);
      //var reg=/(\d{5})(\d{2})(\d{2})/;
      //text =text.replace(reg,'$1-$2-$3');
      return text;
    };
    const DMPriceref = ref();
    return {
      DMConfig,
      OnQuery,
      OnTableChange,
      onSelectChange,
      LoadData,
      GetTableYesNoCol,
      OnCreate,
      OnSend,
      Refresh
    };
  },
  created() {},
  mounted() {
    let _this = this;
    _this.resetTableHeight();
    window.onresize = function () {
      _this.resetTableHeight();
    };
    this.LoadData();
  },
  methods: {
    resetTableHeight() {
      let _this = this;
      var id;
      let tHeader = null;
      if (id) {
        tHeader = document.getElementById(id) ? document.getElementById(id).getElementsByClassName("ant-table-thead")[0] : null;
      } else {
        tHeader = document.getElementsByClassName("ant-table-thead")[0];
      }
      //表格内容距离顶部的距离
      let tHeaderBottom = 0;
      if (tHeader) {
        tHeaderBottom = tHeader.getBoundingClientRect().bottom;
      }
      console.log(tHeaderBottom);

      //页面高度
      let clientHeight = document.documentElement.clientHeight;
      _this.tableHeight = clientHeight - tHeaderBottom - 112 - _this.DMConfig.ForkHeight + 'px';
      /*
      //搜索高度
      let searchBarHeight=0
      //let searchBarHeight = document.getElementById("advanced_search").clientHeight;
      //表格工具栏高度
      let tabletoolHeight = document.getElementById("table_tool").clientHeight;
      _this.tableHeight = (clientHeight - 120 -40 - (searchBarHeight + 16) - (tabletoolHeight + 32) - _this
      	.DMConfig.ForkHeight) + 'px'
      	*/
    }
  },

  watch: {
    // expand(val) {
    // 	let _this=this
    // 	setTimeout(function() {
    // 			_this.resetTableHeight();
    // 	}, 10)
    // }
  }
};
import { useCssVars as _useCssVars } from 'vue';
const __injectCSSVars__ = () => {
  _useCssVars(_ctx => ({
    "1b6b2c58": _ctx.tableHeight
  }));
};
const __setup__ = __default__.setup;
__default__.setup = __setup__ ? (props, ctx) => {
  __injectCSSVars__();
  return __setup__(props, ctx);
} : __injectCSSVars__;
export default __default__;